import React from 'react'

import Layout from '../components/layout'
import HomeTwo from '../components/home/HomeTwo'
import ServiceCapabilities from '../components/services/ServiceCapabilities'
import ServiceOneTeam from '../components/services/ServiceOneTeam'
import ServiceOtherSolutions from '../components/services/ServiceOtherSolutions'
import ServicePageHero from '../components/services/ServicePageHero'
import { CLOUD_INFRASTRUCTURE_CAPABILITIES_EN } from '../constants/serviceCapabilitiesCloudInfrastructure'
import { SERVICE_ONE_TEAM_APPLICATION_EN } from '../constants/serviceOneTeamContent'
import { createServiceOtherSolutionsEn } from '../constants/serviceOtherSolutionsContent'
import { SERVICE_HERO_ASSETS, SERVICE_PAGE_PILLAR_ICONS } from '../constants/serviceHeroAssets'

const CloudInfrastructurePageEn = () => (
  <Layout lang="en" title="Cloud & Infrastructure" meta={{ description: '' }} rootProps={{ className: 'page services service-application-modernization' }}>
    <div className="service-detail-page">
      <ServicePageHero
        sectionId="service-hero"
        label="Services"
        title={'Cloud & Infrastructure.'}
        description={
          'From cloud architecture to DevOps and optimization, we build and scale reliable infrastructures that power modern digital products.'
        }
        heroImage={SERVICE_HERO_ASSETS.cloud.src}
        imageAlt="Cloud and infrastructure illustration"
        imageWidth={SERVICE_HERO_ASSETS.cloud.width}
        imageHeight={SERVICE_HERO_ASSETS.cloud.height}
        pillarIcon={SERVICE_PAGE_PILLAR_ICONS.cloud.src}
        pillarIconWidth={SERVICE_PAGE_PILLAR_ICONS.cloud.width}
      />
      <ServiceCapabilities
        idBase="service-capabilities-cloud-infrastructure"
        sectionTitle="Capabilities built for Scale & Performance."
        tabs={CLOUD_INFRASTRUCTURE_CAPABILITIES_EN}
        contactCtaIsEn
      />
      <HomeTwo lang="en" />
      <ServiceOneTeam
        idBase="service-one-team-cloud-infrastructure"
        {...SERVICE_ONE_TEAM_APPLICATION_EN}
      />
      <ServiceOtherSolutions
        idBase="service-other-solutions-cloud-infrastructure"
        {...createServiceOtherSolutionsEn('cloud')}
      />
    </div>
  </Layout>
)

export default CloudInfrastructurePageEn
